import { defineComponent } from 'vue';
export default defineComponent({
    name: 'FooterRow',
    setup(_props, { slots }) {
        return () => { var _a; return <tr>{(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}</tr>; };
    },
});
